import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseDTO } from '../dtos/response-dto';
import { AuthenticationService } from '../login/authentication/authentication.service';


@Injectable({ providedIn: 'root' })
export class TokenInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // add authorization header with jwt token if available
        let currentUser: ResponseDTO = this.authenticationService.currentUserValue;

        console.log(environment.url);
        
        const isApiUrl = req.url.startsWith(environment.url + '/private');

        if (currentUser && currentUser.token && isApiUrl) {
            req = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        }

        //console.log(req);
        return next.handle(req);
    }
}
